import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

@InputType()
export class FormalizeCommunicationArgs extends ActionArgs {
  @Field(() => String)
  content: string
}

export interface IFormalizeCommunication extends IAction<string, FormalizeCommunicationArgs> {}
